module.exports = __webpack_public_path__ + "img/stock2.14281d58.png";